import Vue from "vue";
import Vuex from "vuex";

import '@mdi/font/css/materialdesignicons.css' // <-- Just here
import Buefy from "buefy";

// veelidate
import { required, confirmed, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

import App from './App.vue'
import router from './router'
import store from './store'
import { $t, $tMixin } from './i18n';
import JwPagination from 'jw-vue-pagination';

import {
	BRadioGroup,
	BCheckboxGroup,
	AppSpinner,
	AppLoading,
	AppPageSection,
	CalcFormCard,
	CalcFormItem,
	AppDropdown,
	AppNumberInput,
	AppTooltip,
	CalcNumberInput
} from "./components";
import Cookies from "js-cookie";


Vue.use(Vuex);
Vue.use(Buefy);

//global  mixins
Vue.mixin($tMixin);

// global components
Vue.component("app-page-section", AppPageSection);
Vue.component("app-dropdown", AppDropdown);
Vue.component("app-number-input", AppNumberInput);
Vue.component("app-loading", AppLoading);
Vue.component("app-spinner", AppSpinner);
Vue.component("app-tooltip", AppTooltip);
Vue.component("calc-form-card", CalcFormCard);
Vue.component("calc-form-item", CalcFormItem);
Vue.component("calc-number-input", CalcNumberInput);
Vue.component("b-radio-group", BRadioGroup);
Vue.component("b-checkbox-group", BCheckboxGroup);

Vue.component('jw-pagination', JwPagination);


//global vars
Vue.config.productionTip = false;

//init app
store
	.dispatch('initAuth')
	.then(() => {
		const user = store.state.user;

		if (user && user.lang) {
			store.dispatch('updateSelectedLang', user.lang);

		} else {
			const urlLangQueryStr = window.location.search.split('&').find(item => {
				return item.toLowerCase().includes("lang=");
			});

			const urlLang = urlLangQueryStr && urlLangQueryStr.split('=')[1];

			if (urlLang) {
				store.dispatch('updateSelectedLang', urlLang);
			} else {
				const cookieLang = Cookies.get('selectedLang')
				if(cookieLang)
					store.dispatch('updateSelectedLang', cookieLang);
				else
				store.dispatch('updateSelectedLang', store.state.selectedLang);
			}
		}
	});

store.subscribe((mutation, state) => {
	if (mutation.type === 'setSelectedLang') {
		const selectedLang = state;

		extend("required", {
			...required,
			message: $t(selectedLang, "Este campo é obrigatório")
		});

		extend("email", {
			...email,
			message: $t(selectedLang, "O endereço de email é inválido")
		});

		extend("confirmed", {
			...confirmed,
			message: $t(selectedLang, "Não coincide com o campo anterior.")
		});
	}
});


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')